module.exports = "/images/sensorsImgPlaceholder1.png?b7996d56e2d4941de84a39a7fb42f213";